/** WCKT / 9Wicket uses DSTONE wallet-login URLs, not iframe HTML. */

export function isWcktLaunchProvider(providerCode) {
  const code = String(providerCode || '').trim().toUpperCase();
  return code === 'WCKT' || code === '9WICKET';
}

/** iGaming 9Wicket (World Casino): provider 141 + game 11539. Not DST WCKT. */
export const IGAMING_9W_API_COMPANY = 'igaming';
export const IGAMING_9W_PROVIDER_CODE = '141';
export const IGAMING_9W_GAME_CODE = '11539';

export function isIgaming9WicketLaunch(providerCode, gameCode, apiCompanyId) {
  const company = String(apiCompanyId || '').trim().toLowerCase();
  if (company && company !== IGAMING_9W_API_COMPANY) {
    return false;
  }
  const provider = String(providerCode || '').trim();
  const game = String(gameCode || '').trim();
  // game_uid 11539 is the 9Wicket identity. The SPA click path often sends
  // display labels or omits providerCode even when the launch API uses 141.
  if (game === IGAMING_9W_GAME_CODE) {
    return true;
  }
  // Provider-tile / lobby clicks send gameCode "0" with provider 141.
  if (provider === IGAMING_9W_PROVIDER_CODE && (game === '' || game === '0')) {
    return true;
  }
  return provider === IGAMING_9W_PROVIDER_CODE && game === IGAMING_9W_GAME_CODE;
}

export function isHttpLaunchUrl(url) {
  try {
    const parsed = new URL(String(url || '').trim());
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
}

export function sanitizeLaunchUrlForLog(url) {
  try {
    const parsed = new URL(String(url || '').trim());
    return `${parsed.protocol}//${parsed.host}${parsed.pathname}`;
  } catch {
    return '';
  }
}

export function navigateTopLevelLaunch(url, assign) {
  const href = String(url || '').trim();
  if (!isHttpLaunchUrl(href)) return false;
  const go = typeof assign === 'function'
    ? assign
    : (target) => {
      window.location.assign(target);
    };
  go(href);
  return true;
}
